export const NANO_BANANA_2_MODEL = 'fal-ai/nano-banana-2/edit';
export const NANO_BANANA_2_VARIANT = 'Nano Banana 2';
export const NANO_BANANA_21_VARIANT = 'Nano Banana 2.1';
export const NANO_BANANA_21_ONLY_PARAMS = ['thinking_level', 'output_format'];
/** Resolutions the 2.1 version rejects. */
export const NANO_BANANA_21_UNSUPPORTED_RESOLUTIONS = ['512', '0.5K'];
